// extracted by mini-css-extract-plugin
export default {"root":"root___dEGIQ","block":"block___ycVEp"};